import { langFor } from "../lib/thai";

/** Status category from the workflow (SA-01 status_category). The pill shows the status NAME; the category picks the colour. */
export type StatusCategory = "todo" | "in_progress" | "done";

interface StatusPillProps {
  name: string;
  category: StatusCategory;
}

export function StatusPill({ name, category }: StatusPillProps) {
  return (
    <span className={`pill cat-${category}`} lang={langFor(name)}>
      {name}
    </span>
  );
}
